import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Compass, Heart, User, PlusSquare, MessageCircle } from 'lucide-react';
import { currentUser } from '../../data/mockData';

export const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="grid grid-cols-6 h-14">
        <Link
          to="/"
          className={`flex flex-col items-center justify-center ${isActive('/') ? 'text-purple-600' : 'text-gray-500'}`}
        >
          <Home className="h-5 w-5" />
          <span className="text-xs mt-1">Home</span>
        </Link>
        <Link
          to="/explore"
          className={`flex flex-col items-center justify-center ${isActive('/explore') ? 'text-purple-600' : 'text-gray-500'}`}
        >
          <Compass className="h-5 w-5" />
          <span className="text-xs mt-1">Explore</span>
        </Link>
        <Link
          to="/create"
          className="flex flex-col items-center justify-center"
        >
          <div className="bg-gradient-to-tr from-purple-600 to-orange-400 rounded-md p-1">
            <PlusSquare className="h-5 w-5 text-white" />
          </div>
        </Link>
        <Link
          to="/messages"
          className={`flex flex-col items-center justify-center ${isActive('/messages') ? 'text-purple-600' : 'text-gray-500'}`}
        >
          <MessageCircle className="h-5 w-5" />
          <span className="text-xs mt-1">Messages</span>
        </Link>
        <Link
          to="/notifications"
          className={`flex flex-col items-center justify-center ${isActive('/notifications') ? 'text-purple-600' : 'text-gray-500'}`}
        >
          <Heart className="h-5 w-5" />
          <span className="text-xs mt-1">Activity</span>
        </Link>
        <Link
          to="/profile"
          className={`flex flex-col items-center justify-center ${isActive('/profile') ? 'text-purple-600' : 'text-gray-500'}`}
        >
          <div className="relative">
            <img 
              src={currentUser.profileImage} 
              alt="Profile" 
              className={`h-5 w-5 rounded-full object-cover ${isActive('/profile') ? 'border-2 border-purple-600' : ''}`} 
            />
          </div>
          <span className="text-xs mt-1">Profile</span>
        </Link>
      </div>
    </div>
  );
};